import { render } from "./ShutdownPhase.vue?vue&type=template&id=6995d24e&scoped=true"
import script from "./ShutdownPhase.vue?vue&type=script&lang=js"
export * from "./ShutdownPhase.vue?vue&type=script&lang=js"

import "./ShutdownPhase.vue?vue&type=style&index=0&id=6995d24e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6995d24e"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox,QIcon,QTooltip,QChip,QBtn,QSelect,QItem,QItemSection,QInput});
